/*
 * umbra-atc-stepper.js (2026-09-09 evening, PDP round 2 part D)
 *
 * Mete: "i want to have an option on buy now button where it will turn into the counter when clicked once
 * (like if that item is already in the bag (same variation), then the add to cart turns into a counter and
 * with those + and - buttons the user can change the quantity), make sure to keep it on theme colors."
 *
 * Loaded by sections/main-product.liquid (buy-buttons block) with defer, only while the block's atc_stepper
 * setting is on and the product is neither a gift card nor a pre-order template. ES5 IIFE, no custom
 * element; re-inits on shopify:section:load for the editor.
 *
 * How it works. The first Add to cart stays the theme's own submit (assets/product-form.js: the drawer opens
 * as today). This script keeps a copy of the cart (GET /cart.js once, then the cart object the theme's own
 * 'on:cart:add' / 'on:line-item:change' events carry; re-fetched on 'dispatch:cart-drawer:refresh',
 * 'on:bfcache:load-restore' and 'on:cart:error') and, whenever the form's variant (input[name=id], already
 * updated when 'on:variant:change' fires) is in the bag while the button is enabled and not js-hidden
 * (sold out / Get Notified / Make a selection stay on the button), hides the button with the hidden
 * attribute (never removed: sticky-atc-panel.js and variant-picker.js keep reading it) and shows
 * [-] [N in bag] [+]. After an add it waits for the button's is-loading to clear so the tick is not cut.
 *
 * A step POSTs the theme's cart change route with JSON {id: line key, quantity, sections, sections_url}
 * for the PLAIN line of that variant (no properties, no selling plan), stepping that line by its own
 * quantity while the count shows the sum of every line of the variant (finish fix 2026-09-10: the sum
 * +/- 1 written to one line went the wrong way once a second line carried properties). With no plain
 * line [-] is disabled (title tooltip) and [+] adds one through /cart/add.js as a new plain line. It hands the
 * response to cart-drawer.renderContents(data, false) (drawer + #cart-icon-bubble re-rendered, drawer not
 * opened; cart page: cart-items.refresh()) and dispatches 'on:line-item:change' in the theme's own detail
 * shape so analytics listeners see it. 0 brings the button back. Requests are serialised: a fast +++ sends
 * one request at a time and the latest target wins. A 422 (stock) reverts the count, writes the message
 * into the block's .js-form-error and disables [+] until the variant changes.
 *
 * Never touches product-form.js, quick-add.js, variant-picker.js, sticky-atc-panel.js or quantity-input.*.
 */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var settings = theme.settings || {};
  var strings = theme.strings || {};
  var cartUrl = routes.cart || '/cart';
  var changeUrl = routes.cartChange || '/cart/change';
  var addUrl = cartUrl + '/add.js';

  function linesFor(cart, vid) {
    var out = [];
    if (!cart || !cart.items) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === vid) out.push(cart.items[i]);
    }
    return out;
  }

  function sumQty(list) {
    var n = 0;
    for (var i = 0; i < list.length; i++) n += Number(list[i].quantity) || 0;
    return n;
  }

  function plainLine(list) {
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      var props = it.properties || {};
      var hasProps = false;
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) { hasProps = true; break; }
      }
      if (!hasProps && !it.selling_plan_allocation) return it;
    }
    return null;
  }

  function Stepper(el) {
    el.umbraStepper = this;
    this.el = el;
    this.form = el.closest('form.js-product-form-main');
    this.block = el.closest('.product-info__block');
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.atcBtn = this.form ? this.form.querySelector('[name="add"]') : null;
    this.errEl = this.block ? this.block.querySelector('.js-form-error') : null;
    this.minus = el.querySelector('[data-step="-1"]');
    this.plus = el.querySelector('[data-step="1"]');
    this.countEl = el.querySelector('[data-count]');
    this.drawer = document.querySelector('cart-drawer');
    var sec = this.drawer ? this.drawer.closest('.shopify-section') : null;
    this.sections = ['cart-icon-bubble'];
    if (sec) this.sections.push(sec.id.replace('shopify-section-', ''));
    this.cart = null;
    this.qty = 0;
    this.shown = false;
    this.busy = false;
    this.busyVid = 0;
    this.pending = 0;
    this.flight = 0;
    this.hidBtn = false;
    this.timer = null;
    if (!this.form || !this.idInput || !this.atcBtn || !this.minus || !this.plus || !this.countEl) return;
    this.bind();
    this.fetchCart();
  }

  Stepper.prototype.alive = function () {
    return document.body.contains(this.el);
  };

  Stepper.prototype.bind = function () {
    var self = this;
    this.minus.addEventListener('click', function () { self.step(-1); });
    this.plus.addEventListener('click', function () { self.step(1); });
    document.addEventListener('on:cart:add', function (e) { self.onCartEvent(e); });
    document.addEventListener('on:line-item:change', function (e) { self.onCartEvent(e); });
    document.addEventListener('on:variant:change', function () {
      if (!self.alive()) return;
      self.plus.disabled = false;
      self.hideError();
      self.render();
      /* product-form.js toggles js-hidden on the button from its own option click handler: look again */
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.render(); }, 60);
    });
    document.addEventListener('dispatch:cart-drawer:refresh', function () { self.fetchCart(); });
    document.addEventListener('on:bfcache:load-restore', function () { self.fetchCart(); });
    document.addEventListener('on:cart:error', function () { self.fetchCart(); });
  };

  Stepper.prototype.onCartEvent = function (e) {
    if (!this.alive()) return;
    if (e && e.detail && e.detail.cart && e.detail.cart.items) {
      this.cart = e.detail.cart;
      this.whenIdle(this.render);
    } else {
      this.fetchCart();
    }
  };

  /* wait for product-form.js to clear is-loading (1400ms after the add) so the tick is not cut; 2s cap */
  Stepper.prototype.whenIdle = function (fn) {
    var self = this;
    var tries = 0;
    var tick = function () {
      if (self.atcBtn.classList.contains('is-loading') && tries < 20) {
        tries++;
        setTimeout(tick, 100);
        return;
      }
      fn.call(self);
    };
    tick();
  };

  Stepper.prototype.fetchCart = function () {
    var self = this;
    if (!this.alive()) return;
    fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.items) {
          self.cart = data;
          self.whenIdle(self.render);
        }
      })
      .catch(function () {});
  };

  Stepper.prototype.render = function () {
    if (this.busy) return;
    var lines = linesFor(this.cart, Number(this.idInput.value));
    var qty = sumQty(lines);
    var show = qty > 0 && !this.atcBtn.disabled && !this.atcBtn.classList.contains('js-hidden');
    var active = document.activeElement;
    this.qty = qty;
    this.countEl.textContent = String(qty);
    /* [-] steps the plain line only; when every line of the variant carries properties or a selling plan it is off */
    var noPlain = show && !plainLine(lines);
    this.minus.disabled = noPlain;
    if (noPlain) {
      this.minus.setAttribute('title', (window.umbraI18n && window.umbraI18n.atc_stepper_minus_disabled_title) || 'Change the quantity in your bag');
    } else {
      this.minus.removeAttribute('title');
    }
    if (show) {
      /* hidBtn: only a button this script hid is brought back (product-form.js hides it itself on a stock failure) */
      if (!this.atcBtn.hidden) {
        this.atcBtn.hidden = true;
        this.hidBtn = true;
      }
      this.el.hidden = false;
      if (!this.shown && active === this.atcBtn) this.plus.focus();
    } else {
      this.el.hidden = true;
      if (this.hidBtn) {
        this.atcBtn.hidden = false;
        this.hidBtn = false;
      }
      if (this.shown && active && this.el.contains(active)) this.atcBtn.focus();
    }
    this.shown = show;
  };

  Stepper.prototype.hideError = function () {
    if (this.errEl && !this.errEl.hidden && this.errEl.getAttribute('data-umbra-stepper-error')) {
      this.errEl.hidden = true;
      this.errEl.textContent = '';
      this.errEl.removeAttribute('data-umbra-stepper-error');
    }
  };

  Stepper.prototype.showError = function (msg) {
    if (!this.errEl) return;
    this.errEl.textContent = msg;
    this.errEl.hidden = false;
    this.errEl.setAttribute('data-umbra-stepper-error', '1');
  };

  /* pending is a delta (steps queued while a request is out); the count shows the last rendered sum plus the in-flight and queued deltas */
  Stepper.prototype.step = function (delta) {
    if (delta > 0 && this.plus.disabled) return;
    if (delta < 0 && this.minus.disabled) return;
    if (this.busy) {
      /* the variant changed under an outstanding request: a step for another variant is dropped */
      if (Number(this.idInput.value) !== this.busyVid) return;
      this.pending += delta;
      this.countEl.textContent = String(Math.max(0, this.qty + this.flight + this.pending));
      return;
    }
    this.countEl.textContent = String(Math.max(0, this.qty + delta));
    this.send(delta);
  };

  /* the PLAIN line is stepped by its own quantity: with the variant on two lines (one carrying properties or a
     selling plan) the count is the sum, but sum +/- 1 written to one line moved the bag the wrong way. Without a
     plain line [+] adds one as a new plain line (/cart/add.js; a change by variant id would land on the first line
     of the variant whatever its properties) and [-] is disabled by render(). */
  Stepper.prototype.send = function (delta) {
    var self = this;
    var vid = Number(this.idInput.value);
    var lines = linesFor(this.cart, vid);
    var line = plainLine(lines);
    var sum = sumQty(lines);
    var lineFrom = line ? Number(line.quantity) || 0 : 0;
    var lineTo = Math.max(0, lineFrom + delta);
    var target = sum + lineTo - lineFrom;
    var status = 0;
    if (lineTo === lineFrom) {
      this.pending = 0;
      this.render();
      return;
    }
    this.busy = true;
    this.busyVid = vid;
    this.flight = lineTo - lineFrom;
    this.pending = 0;
    this.el.setAttribute('aria-busy', 'true');
    var body = { id: line ? line.key : vid, quantity: lineTo, sections: this.sections, sections_url: window.location.pathname };
    fetch(line ? changeUrl : addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { status = r.status; return r.text(); })
      .then(function (text) {
        var data = null;
        /* the change route can answer plain text: kept as the message */
        try { data = JSON.parse(text); } catch (e) { data = { description: text }; }
        if (status < 200 || status >= 300 || !data || !(data.items || data.id)) {
          self.fail(data, status, sum);
          return null;
        }
        self.hideError();
        if (data.items) {
          self.cart = data;
          self.afterChange(data, vid, sum, target);
          return null;
        }
        /* add path: the response is the line item; the cache is refreshed before the drawer and the event */
        return fetch(cartUrl + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            if (c && c.items) self.cart = c;
            self.afterChange(data, vid, sum, target);
          });
      })
      .catch(function () { self.fail(null, status, sum); })
      .then(function () { self.finish(); });
  };

  Stepper.prototype.afterChange = function (data, vid, from, target) {
    this.plus.disabled = false;
    if (this.drawer && typeof this.drawer.renderContents === 'function') {
      try { this.drawer.renderContents(data, false); } catch (e) {}
    } else {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        bubble.innerHTML = data.sections['cart-icon-bubble'];
      }
      var cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.refresh === 'function' && window.location.pathname === cartUrl) {
        cartItems.refresh();
      }
    }
    if (from !== target) {
      this.el.dispatchEvent(new CustomEvent('on:line-item:change', {
        bubbles: true,
        detail: { cart: this.cart, variantId: vid, oldQuantity: from, newQuantity: target }
      }));
    }
  };

  Stepper.prototype.fail = function (data, status, from) {
    var msg = '';
    if (data) {
      if (typeof data.description === 'string') msg = data.description;
      else if (typeof data.errors === 'string') msg = data.errors;
      else if (typeof data.message === 'string') msg = data.message;
    }
    /* a text body is shown only when it reads as a message, not a page */
    msg = msg.replace(/^\s+|\s+$/g, '');
    if (!msg || msg.length > 240 || msg.indexOf('<') >= 0) msg = strings.cartError || (window.umbraI18n && window.umbraI18n.atc_stepper_generic_error) || 'Something went wrong.';
    this.pending = 0;
    this.countEl.textContent = String(from);
    this.showError(msg);
    if (status === 422) this.plus.disabled = true;
    this.fetchCart();
  };

  Stepper.prototype.finish = function () {
    this.busy = false;
    this.busyVid = 0;
    this.flight = 0;
    this.el.removeAttribute('aria-busy');
    if (this.pending) {
      var next = this.pending;
      this.pending = 0;
      this.send(next);
      return;
    }
    this.render();
  };

  function init(root) {
    /* nothing to do without the APIs used (fetch, CustomEvent, closest): the button stays as it is */
    if (!window.fetch || typeof window.CustomEvent !== 'function' || !window.Element || !Element.prototype.closest) return;
    var a = settings.afterAtc;
    if (a && a !== 'drawer' && a !== 'nothing') return;
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-umbra-atc-stepper]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].umbraStepper) new Stepper(list[i]);
    }
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
